module.exports = __webpack_public_path__ + "html/following_12116117825ee99ab9d8b0ac210d2599.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/following.html
// module id = jPnc
// module chunks = 9